import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { urls, currentLang } from "../../shared/seo/links";
import "./lawyers.css";

/**
 * Sidebar search. A city, and a bar level within it, are part of the URL
 * (/Avocats/sfax/cassation): those are the indexed pages. The name, and a
 * bar level across the whole country, are search filters: they travel in
 * the history state and Lawyers.jsx passes them to the directory call.
 */
export default function LawyerAdvancedSearch({ governorate, barLevel, name: initialName }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const lang = currentLang();
  const [state, setState] = useState(governorate ? governorate.key : "");
  const [level, setLevel] = useState(barLevel ? String(barLevel.key) : "");
  const [name, setName] = useState(initialName || "");

  // The page changes city/level through links too: keep the form in sync.
  useEffect(() => {
    setState(governorate ? governorate.key : "");
    setLevel(barLevel ? String(barLevel.key) : "");
  }, [governorate, barLevel]);
  useEffect(() => {
    setName(initialName || "");
  }, [initialName]);

  function searchHandler(e) {
    e.preventDefault();
    const gov = urls.findGovernorate(state);
    const barLevel = level ? Number(level) : undefined;
    navigate(urls.lawyersPath(lang, { governorate: gov, barLevel: gov ? barLevel : undefined }), {
      state: { name: name.trim(), barLevel: gov ? undefined : barLevel },
    });
  }

  return (
    <aside className="col-md-12 col-lg-4">
      <form className="avc-filter" onSubmit={searchHandler} role="search">
        <h2 className="avc-filter__title">
          <i className="fas fa-sliders-h" aria-hidden="true"></i>
          {t("Search_Filter")}
        </h2>
        <label className="avc-filter__field">
          <span className="avc-filter__label">{t("home_search_name_label")}</span>
          <span className="avc-filter__control">
            <i className="fas fa-user-tie" aria-hidden="true"></i>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("ex")}
            />
          </span>
        </label>
        <label className="avc-filter__field">
          <span className="avc-filter__label">{t("home_search_city_label")}</span>
          <span className="avc-filter__control">
            <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
            <select value={state} onChange={(e) => setState(e.target.value)}>
              <option value="">{t("home_all_cities")}</option>
              {urls.GOVERNORATES.map((gov) => (
                <option key={gov.key} value={gov.key}>
                  {urls.governorateName(gov, lang)}
                </option>
              ))}
            </select>
          </span>
        </label>
        <label className="avc-filter__field">
          <span className="avc-filter__label">{t("lawyers_level_label")}</span>
          <span className="avc-filter__control">
            <i className="fas fa-gavel" aria-hidden="true"></i>
            <select value={level} onChange={(e) => setLevel(e.target.value)}>
              <option value="">{t("lawyers_all_levels")}</option>
              {[...urls.BAR_LEVELS]
                .sort((a, b) => b.key - a.key)
                .map((item) => (
                  <option key={item.key} value={item.key}>
                    {item[lang]}
                  </option>
                ))}
            </select>
          </span>
        </label>
        <button type="submit" className="avc-btn avc-btn--gold avc-btn--block">
          <i className="fas fa-search" aria-hidden="true"></i>
          {t("search")}
        </button>
      </form>
    </aside>
  );
}
